<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">外协单号：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="外协单号"
                clearable
                v-model="queryData.order_no"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">样本册名称：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="样本册名称"
                clearable
                v-model="queryData.product_name"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">外协商：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="外协商"
                clearable
                v-model="queryData.company_name"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
          <el-select
            @change="outStoreChange(outstore_name)"
            size="mini"
            v-model="outstore_name"
            placeholder="请选择"
            style="margin-left:20px"
          >
            <el-option
              v-for="item in outsotreArr"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          v-if="outstore_name === '未出库'"
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
        >
          <el-table-column
            label="外协日期"
            prop="outsource_date"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="外协单号"
            prop="order_no"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="样本册名称"
            prop="product_name"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="外协商"
            prop="company_name"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="备注"
            prop="remark"
            align="center"
          ></el-table-column>
          <el-table-column
            v-if="role_name === '超级权限' || role_name === '软件管理'"
            label="操作"
            width="60"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-document-add"
                circle
                plain
                @click.stop.prevent="addHandler(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-else style="height:100%">
          <el-table
            :data="storeds"
            size="mini"
            stripe
            border
            height="100%"
            style="width: 100% border:1px solid #d1d1d1"
            header-row-class-name="list-header-row"
            row-class-name="list-row"
            @selection-change="selectHandler"
          >
            <el-table-column
              type="selection"
              width="40"
              align="center"
              :selectable="selectableHandler"
            ></el-table-column>
            <el-table-column
              label="出库日期"
              prop="outstore_date"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="出库单号"
              prop="outstore_no"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="外协单号"
              prop="order_no"
              width="100"
              align="center"
            ></el-table-column>
            <el-table-column
              label="样本册名称"
              prop="product_name"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              label="外协商"
              prop="company_name"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              label="备注"
              prop="remark"
              align="center"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="90"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="role_name === '超级权限' || role_name === '软件管理'"
                  type="primary"
                  size="mini"
                  icon="el-icon-document-add"
                  circle
                  plain
                  @click.stop.prevent="addHandler(scope.row)"
                ></el-button>
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-view"
                  circle
                  plain
                  @click.stop.prevent="viewHandler(scope.row)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <!--列表数据 结束-->
    <!-- 新增表单对话框 -->
    <outstore-dialog-form ref="DForm" :parent="this" />
  </div>
</template>

<script>
import OutstoreDialogForm from "@/views/modules/store/outstore/Form";
export default {
  data: function() {
    return {
      ds: [],
      storeds: [],
      selectedIds: [],
      outsotreArr: [],
      // 分页
      queryData: {
        order_no: "",
        product_name: "",
        company_name: "",
        type: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      outstore_name: "",
      operator_id: sessionStorage.getItem("operator_id"),
      role_name: sessionStorage.getItem("role_name")
    };
  },
  created: function() {},
  mounted: function() {
    this.loadData();
    this.outsotreArr = [{ value: "未出库" }, { value: "已出库" }];
    this.outstore_name = "未出库";
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(
        _this.$apis.getOutsourceOutstoreList,
        _this.queryData,
        function(res) {
          let _json = res.data;
          if (_json.status && _json.status === "logout") {
            _this.logout();
          } else {
            _this.ds = _json.datalist;
            _this.queryData.totalCount = _json.totalCount;
          }
        }
      );
    },
    loadStoreData: function() {
      let _this = this;
      _this.queryData.type = "0";
      _this.post(_this.$apis.getOutstoreList, _this.queryData, function(res) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = [];
          _this.storeds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
        }
      });
    },
    // 出库更改事件
    outStoreChange: function(value) {
      if (value === "未出库") {
        this.loadData();
      } else {
        this.loadStoreData();
      }
    },
    // 新增
    addHandler: function(_row) {
      let formId = _row.outsource_order_id;
      this.$refs.DForm.addHandler(formId);
    },
    // 浏览
    viewHandler: function(_row) {
      let formId = _row.id;
      let isUsed = _row.is_used;
      this.$refs.DForm.viewHandler(formId, isUsed);
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        this.queryData.order_no = "";
        this.queryData.product_name = "";
        this.queryData.company_name = "";
      }
      if (this.outstore_name === "未出库") {
        this.loadData();
      } else {
        this.loadStoreData();
      }
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      if (this.outstore_name === "未出库") {
        this.loadData();
      } else {
        this.loadStoreData();
      }
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      if (this.outstore_name === "未出库") {
        this.loadData();
      } else {
        this.loadStoreData();
      }
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      if (this.outstore_name === "未出库") {
        this.loadData();
      } else {
        this.loadStoreData();
      }
    },
    // 多选事件
    selectHandler: function(selection) {
      this.selectedIds = [];
      for (let i = 0; i < selection.length; ++i) {
        this.selectedIds.push(selection[i].id);
      }
    },
    // 删除
    delHandler: function() {
      let _this = this;
      let _ids = _this.selectedIds.join(",");

      if (_ids.length === 0) {
        _this.$message({
          type: "warning",
          message: "至少选择一条数据"
        });
      } else {
        _this
          .$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            let _params = {
              ids: _ids,
              operator_id: _this.operator_id
            };
            // ajax提交至服务器，删除数据
            _this.post(_this.$apis.delOutstoreList, _params, function(res) {
              let _json = res.data;
              if (_json.status && _json.status === "logout") {
                _this.logout();
              } else {
                if (_json.status === "ok") {
                  _this.loadStoreData();
                  _this.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                } else {
                  _this.$message({
                    type: "error",
                    message: "无数据更新!"
                  });
                }
              }
            });
          })
          .catch(() => {
            _this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      }
    },

    // 通过该方法，控制列表 checkbox 列是否允许勾选
    selectableHandler: function(_row, _index) {
      if (_row.is_used === "1") {
        return false;
      } else {
        return true;
      }
    }
  },
  components: {
    OutstoreDialogForm
  }
};
</script>
